<template>
  <div
    class="bg-background-neutral-secondary flex cursor-pointer items-start justify-between rounded-2xl p-4"
    :class="{ 'opacity-60': isLoading }"
    type="button"
    @click="toggleSelection"
  >
    <div class="flex w-full items-start space-x-3">
      <FreeCheckbox
        :checked="passenger.isSelected"
        :disabled="!passenger.iin || isLoading"
        class="pointer-events-none mt-2"
      >
        <template #content></template>
      </FreeCheckbox>

      <div class="w-full">
        <div class="flex items-start justify-between space-x-2">
          <div>
            <div
              class="flex flex-wrap gap-x-2 font-medium"
              :class="
                passenger.iin
                  ? 'text-text-neutral-primary'
                  : 'text-text-neutral-quaternary'
              "
            >
              <p class="break-all">
                {{ passenger.firstName }}
              </p>
              <p class="break-all">
                {{ passenger.lastName }}
              </p>
            </div>
            <div class="text-static-grey text-xs">
              {{ t(`passengersData.passengerTypes.${passenger.type}.text`) }}
            </div>
          </div>
          <div
            v-if="isLoading || price === undefined"
            class="shimmer h-5 w-14 rounded-xl bg-gray-300"
          ></div>
          <p
            v-else
            class="whitespace-nowrap font-medium"
            :class="
              passenger.iin
                ? 'text-text-neutral-primary'
                : 'text-text-neutral-quaternary'
            "
          >
            <span v-price="passenger.productPriceAmount || price" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeCheckbox } from 'freedom-shared';

  const props = defineProps<{
    passenger: {
      fullName: string;
      firstName: string;
      lastName: string;
      isSelected: boolean;
      passportDate: string;
      productPriceAmount: string;
      type: string;
      iin?: string;
    };
    errorMessage?: string;
    isLoading?: boolean;
    price: string | number;
  }>();

  const emit = defineEmits<{
    onUpdateIsSelected: [boolean];
    onShowAlert: [];
  }>();

  const { t } = useI18n();

  const toggleSelection = () => {
    if (props.isLoading) {
      return; // Блокируем клик во время загрузки/актуализации
    }

    if (props.passenger?.iin) {
      emit('onUpdateIsSelected', !props.passenger.isSelected);
      return;
    }
    emit('onShowAlert');
  };
</script>
